import { MASTER_DATA } from '../constants'

export const setMasterDataDetails = (masterData) => ({
    type: MASTER_DATA.SET_MASTER_DATA,
    payload: masterData,
})

export const clearMasterData = () => ({
    type: MASTER_DATA.CLEAR,
})
